backgroundStyleProp = require 'utils/background-style-prop'

###
# Модель перевозчика
###
App.Carrier = DS.Model.extend
  name              : DS.attr 'string'
  annotation        : DS.attr 'string'
  description       : DS.attr 'string'
  logo              : DS.attr 'mixed'
  coveragePhoto     : DS.attr 'mixed'
  citiesList        : DS.attr 'mixed'
  speedRating       : DS.attr 'number' #0-100
  priceRating       : DS.attr 'number' #0-100
  qualityRating     : DS.attr 'number' #0-100
  status            : DS.attr 'string' #connected, sent

  logoPlaceholder   : 'images/carrier-placeholder@2x.png'

  # Вычисляемые поля
  isConnected       : Ember.computed.equal 'status', 'connected'
  isSent            : Ember.computed.equal 'status', 'sent'

  showRating        : Ember.computed.and 'speedRating', 'priceRating', 'qualityRating'

  safeLogoSmall     : Ember.computed 'logo.small', ->
    result = @get('logo.small') or @get('logoPlaceholder')
    result.htmlSafe()

  safeLogoMedium     : Ember.computed 'logo.medium', ->
    result = @get('logo.medium') or @get('logoPlaceholder')
    result.htmlSafe()

  logoMediumBackground: backgroundStyleProp('safeLogoMedium')
  logoSmallBackground:  backgroundStyleProp('safeLogoSmall')
